import Vue from 'vue'
import domUtils from 'util/dom-utils'
import log from 'util/logger'

export function createAndMountInstance(
  existingInstance: Vue,
  widget,
  divId: string,
  props: any = {}
): Promise<Vue> {
  return new Promise((resolve) => {
    if (existingInstance) {
      existingInstance.$destroy()
    }
    // if the dom element already exists, no need to wait for dom ready
    if (document.getElementById(divId)) {
      resolve(createInstance(widget, divId, props))
      return
    }
    domUtils.onDomReady().then(() => {
      if (document.getElementById(divId)) {
        resolve(createInstance(widget, divId, props))
        return
      }
      log.warn(`Widget not loaded at dom ready. Could not find div with id ${divId}. Trying again shortly...`)
      setTimeout(() => {
        if (document.getElementById(divId)) {
          resolve(createInstance(widget, divId, props))
          return
        }
        log.warn(`Still unable to find widget div with id ${divId}`)
        resolve(null)
      }, 50)
    })
  })
}

function createInstance(widget, divId: string, props) {
  return new Vue({
    el: `#${divId}`,
    render: h => h(widget, {
      attrs: { id: divId },
      props
    })
  })
}
